import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { Box as l, Skeleton as h, Alert as g, Stack as y, Card as f, CardHeader as k, Typography as d, CardContent as x, Button as S } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { w as b, O as D } from "../../index-DNTqwtVt.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import { assessment as N } from "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { prettyDate as T } from "../../helpers/dates.js";
import { TableComponent as c } from "../table/table.js";
const er = ({ studentId: i, classCode: m, selectedDateRange: u, onTaskClick: t, courseId: s }) => {
  const { isPending: o, error: r, data: a } = new N.GradbookResults({
    studentId: Number(i),
    dateRange: u,
    allPublished: !0,
    classCode: m,
    courseId: s
  }).ToQuery();
  return o ? /* @__PURE__ */ p(l, { children: [
    /* @__PURE__ */ e(h, {}),
    /* @__PURE__ */ e(
      c,
      {
        columns: ["Task", "Due", "Weighting", "Results"],
        rows: [],
        isPending: !0,
        numSticky: 1
      }
    )
  ] }) : r ? /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(g, { severity: "error", children: r.detail }) }) : /* @__PURE__ */ p(y, { gap: 3, children: [
    Object.keys(a.Tasks).map((n) => /* @__PURE__ */ e(C, { studentId: Number(i), name: n, results: a.Tasks[n], summary: a.GradeSummary[n], onTaskClick: t }, n)),
    Object.keys(a.Tasks).length == 0 && /* @__PURE__ */ e(b, { children: "No summary assessment results" })
  ] });
}, C = ({ name: i, results: m, summary: u, onTaskClick: t }) => {
  const { settings: s } = D();
  let o = i;
  return s != null && s.useClassName && (o = m[0].ClassName), /* @__PURE__ */ p(f, { children: [
    /* @__PURE__ */ e(
      k,
      {
        title: /* @__PURE__ */ p(l, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0px 10px" }, children: [
          /* @__PURE__ */ e(d, { fontSize: "1.5rem", children: o }),
          /* @__PURE__ */ e(d, { variant: "h4", children: u })
        ] })
      }
    ),
    /* @__PURE__ */ e(x, { sx: { p: "0 !important" }, children: /* @__PURE__ */ e(
      c,
      {
        columns: ["Task", "Due", "Weighting", "Results"],
        rows: m.map(
          (r) => ({
            Task: /* @__PURE__ */ e(S, { onClick: () => t == null ? void 0 : t(r.TaskID), children: r.Task }),
            Due: T(r.DueDate),
            Weighting: r.Weighting,
            Results: `${r.MaxMark > 0 && r.Mark >= 0 ? `${r.Mark}/${r.MaxMark}` : ""} ${r.Grade}`
          })
        ),
        isPending: !1,
        numSticky: 1
      }
    ) })
  ] });
};
export {
  er as AssessmentSummary
};
//# sourceMappingURL=AssessmentSummary.js.map
